"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddUser = function AddUser(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: props.backgroundColor
  }), _react.default.createElement("path", {
    d: "M14.5834 11.9791H13.0209V10.4166C13.0209 10.2785 12.966 10.146 12.8683 10.0483C12.7707 9.95062 12.6382 9.89575 12.5 9.89575C12.3619 9.89575 12.2294 9.95062 12.1318 10.0483C12.0341 10.146 11.9792 10.2785 11.9792 10.4166V11.9791H10.4167C10.2786 11.9791 10.1461 12.034 10.0484 12.1316C9.95075 12.2293 9.89587 12.3618 9.89587 12.4999C9.89587 12.6381 9.95075 12.7705 10.0484 12.8682C10.1461 12.9659 10.2786 13.0208 10.4167 13.0208H11.9792V14.5833C11.9792 14.7214 12.0341 14.8539 12.1318 14.9515C12.2294 15.0492 12.3619 15.1041 12.5 15.1041C12.6382 15.1041 12.7707 15.0492 12.8683 14.9515C12.966 14.8539 13.0209 14.7214 13.0209 14.5833V13.0208H14.5834C14.7215 13.0208 14.854 12.9659 14.9517 12.8682C15.0493 12.7705 15.1042 12.6381 15.1042 12.4999C15.1042 12.3618 15.0493 12.2293 14.9517 12.1316C14.854 12.034 14.7215 11.9791 14.5834 11.9791Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M16.6667 16.6665H13.0209C13.0209 16.6557 13.0199 16.6451 13.0192 16.6344C14.071 16.5023 15.0329 15.9743 15.709 15.1578C16.3852 14.3414 16.7247 13.298 16.6586 12.24C16.5924 11.1821 16.1255 10.1891 15.3529 9.46331C14.5802 8.73752 13.5601 8.3335 12.5 8.3335C11.44 8.3335 10.4198 8.73752 9.64719 9.46331C8.87458 10.1891 8.40766 11.1821 8.34148 12.24C8.2753 13.298 8.61486 14.3414 9.291 15.1578C9.96714 15.9743 10.929 16.5023 11.9808 16.6344C11.9801 16.6451 11.9792 16.6557 11.9792 16.6665H8.33335C7.2283 16.6666 6.16853 17.1056 5.38714 17.887C4.60576 18.6684 4.16675 19.7281 4.16669 20.8332V21.8159C6.45816 23.8663 9.42512 24.9999 12.5 24.9999C15.5749 24.9999 18.5419 23.8663 20.8334 21.8159V20.8377C20.8334 20.8361 20.8334 20.8348 20.8334 20.8332C20.8333 19.7281 20.3943 18.6684 19.6129 17.887C18.8315 17.1056 17.7717 16.6666 16.6667 16.6665Z",
    fill: props.foregroundColor
  }));
};

AddUser.defaultProps = {
  altText: "Add User",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
AddUser.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = AddUser;
exports.default = _default;